import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import {
	MORNINGSTAR_STYLE_BOX_CATEGORY_KEY,
	MORNINGSTAR_STYLE_BOX_COMPONENT_KEY,
} from '../MorningstarStyleBox.meta.js';

const rawCssPrefix = `
	font-size: 9px;
	padding: 3px 0;
	color: #6C6E70;
`;

export default InjectedStyledComponent(
	'div',
	MORNINGSTAR_STYLE_BOX_CATEGORY_KEY,
	MORNINGSTAR_STYLE_BOX_COMPONENT_KEY,
	['morningstarStyleBoxTick'],
	rawCssPrefix,
);
